export const UPLOAD_TYPES = {
  ORGANIZATION: `organization-avatar`,
  USER: `profile-avatar`,
  PROJECT: `project-avatar`,
  VEHICLE: `vehicle-avatar`,
  SERVICE_REPORT: `service-report-image`,
  PROJECT_STYLE_FAVICON: `project-style-image-favicon`,
  PROJECT_STYLE_LOGO: `project-style-image-logo`,
  PROJECT_STYLE_BANNER: `project-style-image-banner`,
};

export const generateAttachmentName = (type: any) => {
  return `${type}_${new Date().getTime()}.jpg`;
};

export const MAX_FAVICON_SIZE = 524288; // 0.5MB (512 x 512)

export const MAX_AVATAR_IMAGE_SIZE = 1048576; // 1MB (1024 x 1024)

export const MAX_ATTACHMENT_IMAGE_SIZE = 1048576; // 1MB (1024 x 1024)
